import {createAction, props} from "@ngrx/store";
import {ResearchQueue} from "../../models/ResearchQueue";

export const UPDATE = '[ResearchQueue] Update';
export const REFRESH = '[ResearchQueue] Refresh';
export const update = createAction(UPDATE, props<{ researchQueue: ResearchQueue[] }>());
export const refresh = createAction(REFRESH);
